import React from 'react';
import Utilities from '../Utilites/Utilies';
import Countries from '../Countries/Countries';

const Home = () => {
  return (
    <div className="container mx-auto px-10">
      <Utilities />
      <Countries />
      
    </div>
  );
};

export default Home;
